import client from "./client";

const UserService = {};

UserService.get = function () {
  return client.get("/user");
};

UserService.getByRole = function (roleId) {
  return client.get(`/user/by-role/${roleId}`);
};

UserService.login = function (data) {
  return client.post("/user/authenticate", data);
};

UserService.me = function () {
  return client.get("/user/me");
};

UserService.create = function (data) {
  return client.post(`/user/`, data);
};

UserService.update = function (userId, data) {
  return client.put(`/user/${userId}`, data);
};

UserService.changeProfile = function (data) {
  return client.put(`/user/update-profile/`, data);
};

UserService.changePassword = function (data) {
  return client.put(`/user/change-password`, data);
};

UserService.delete = function (userId) {
  return client.del(`/user/${userId}`);
};

export default UserService;
